import React, {memo, useCallback, useMemo, useState} from 'react';
import {PasswordContainer} from '../../../../components/PasswordContainer';
import {SettingsPageContainer} from '../../../../components/Settings/SettingsPageContainer';
import {SettingInputComponent} from '../../../../components/Settings/SettingInputComponent';
import {useKeyboard} from '../../../../hooks/keyboard';
import {useMessage} from '../../../../hooks/message';
import {useRPC} from '../../../../hooks/rpc';
import {useHistory} from 'react-router-dom';
import {DEVELOPER_URL} from '../../index';
import {SelectItem} from '../../../../components/Select';
import {SettingSelectComponent} from '../../../../components/Settings/SettingSelectComponent';
import {useLocalization} from "../../../../hooks/localization";

const OS_OPTION_LIST: SelectItem<'ios' | 'android'>[] = [
    {
        value: 'ios',
        label: 'iOS',
    },
    {
        value: 'android',
        label: 'android',
    },
];

export const UserEditPushTokenScreen = memo(function UserEditPushTokenScreen() {
    const {t} = useLocalization();
    const [setActiveInput, renderKeyboard, currentInput] = useKeyboard();
    const {success, failure} = useMessage();
    const [rpc] = useRPC();
    const history = useHistory();

    const [os, setOS] = useState<SelectItem<'ios' | 'android'>>(null);
    const [token, setToken] = useState('');

    const onBackPressed = useCallback(() => {
        history.push(DEVELOPER_URL);
    }, [history]);

    const onSavePressed = useCallback(() => {
        rpc.updateFCMPushToken({os: os?.value, token})
            .then(() => {
                success(t('successfully_saved'));
                onBackPressed();
            })
            .catch(failure);
    }, [
        t,
        rpc,
        success,
        failure,
        onBackPressed,
        os,
        token,
    ]);

    const buttons = useMemo(() => [
        {
            text: t('save'),
            className: 'blue',
            onClick: onSavePressed,
        },
    ], [t, onSavePressed]);

    const onBlur = useCallback(() => {
        setActiveInput(null);
    }, [setActiveInput]);

    return (
        <PasswordContainer requiredRole='admin' isFullscreen={true}>
            <SettingsPageContainer
                className='service-edit'
                buttons={buttons}
                backUrl={DEVELOPER_URL}
                currentInput={currentInput}>
                <div className='content-divider'>
                    <div className='content-wrapper'>
                        <SettingSelectComponent
                            label='OS'
                            options={OS_OPTION_LIST}
                            onChange={setOS}
                            value={os}/>
                        <SettingInputComponent
                            placeholder='Token'
                            label='Token'
                            value={token}
                            setValue={setToken}
                            setActiveInput={setActiveInput}
                            onBlur={onBlur}/>
                    </div>
                </div>
            </SettingsPageContainer>
            {
                renderKeyboard()
            }
        </PasswordContainer>
    );
});
